/**
 * Montreal-local date formatters used across the accounts feature.
 *
 * Why these exist alongside `formatDate` / `formatDateTime` in `@/lib/utils`:
 * the accounts tables explicitly require the ISO-style `yyyy-mm-dd` and
 * `yyyy-mm-dd HH:MM:SS` shapes (sortable as strings, tabular-nums aligned).
 * The general-purpose `formatDateTime` is locale-aware and returns things
 * like "Apr 20, 2026 12:15 PM" — great for prose, not for tables.
 *
 * Both helpers pin the zone to `America/Montreal` per the platform CLAUDE.md.
 */

/** `yyyy-mm-dd` in America/Montreal (en-CA gives ISO ordering by default). */
export function fmtLocalDate(iso: string): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Montreal' })
    .format(new Date(iso));
}

/** `yyyy-mm-dd HH:MM:SS` (24h) in America/Montreal. */
export function fmtLocalDateTime(iso: string): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Montreal',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false,
  }).formatToParts(new Date(iso));
  const m: Record<string, string> = {};
  for (const p of parts) m[p.type] = p.value;
  return `${m.year}-${m.month}-${m.day} ${m.hour}:${m.minute}:${m.second}`;
}
